import type { FunctionComponent } from "react";

import { ImageSize } from "~/components/article/article-leading/article-leading-images/enums";
import type { DefaultComponentsProvider } from "~/components/article/article-render";

import MascotDesktop from "./mascot-desktop.png";
import MascotMobile from "./mascot-mobile.png";
import {
  LeadingContainer,
  LeadingImageContainer,
  StyledMascotDesktop,
  StyledMascotDesktopContainer,
  StyledMascotMobile,
  StyledMascotMobileContainer,
  StyledStars,
} from "./styles";

type Props = {
  provider: DefaultComponentsProvider;
};

export const GenericPostiesLeading: FunctionComponent<Props> = ({ provider }) => (
  <LeadingContainer>
    <StyledMascotDesktopContainer>
      <StyledMascotDesktop alt={MascotDesktop.alt} src={MascotDesktop.src} />
    </StyledMascotDesktopContainer>
    <StyledMascotMobileContainer>
      <StyledMascotMobile alt={MascotMobile.alt} src={MascotMobile.src} />
    </StyledMascotMobileContainer>
    <LeadingImageContainer>
      {provider.leading({
        responsiveDescriptionVariants: {
          desktopUp: "show",
          mobileUp: "hidden",
          tabletUp: "show",
        },
        responsiveImageVariants: {
          desktopUp: "normal",
          mobileUp: "square",
          tabletUp: "normal",
        },
        responsiveVariants: {
          desktopUp: ImageSize["1200x800"],
          mobileUp: ImageSize["768x768"],
          tabletUp: ImageSize["1020x680"],
        },
      })}
      <StyledStars />
    </LeadingImageContainer>
  </LeadingContainer>
);
